<template>
  <div class="nav" :class="{ 'bg-white': isFixed }">
    <div class="main">
      <img src="@/assets/img/logo-new.png" alt="" class="logo" />
      <span class="nav-link" :class="{ active: ind == 0 }" @click="jump(0)">HOME</span>
      <div class="nav-link" :class="{ active: ind == 1 }" @click="jump(1)" @mouseenter="isShow = true" @mouseleave="mouseleave">
        <span>LOANS</span>
        <ul v-show="ind == -1 || isShow">
          <li class="loans-item" :class="{ active: hoverInd == 1 }" @click.stop="jump(1)" @mouseenter="mouseenter(1)">
            <img src="@/assets/img/OK.png" alt="">
            <span>OKash PERSONAL LOAN</span>
          </li>
          <li class="loans-item" :class="{ active: hoverInd == 2 }" @click.stop="jump(2)" @mouseenter="mouseenter(2)">
            <img src="@/assets/img/EM.png" alt="">
            <span>EaseMoni PERSONAL LOAN</span>
          </li>
        </ul>
      </div>
      <span class="nav-link" :class="{ active: ind == 3 }" @click="jump(3)">SAVINGS</span>
      <span class="nav-link" :class="{ active: ind == 4 }" @click="jump(4)">NEWS & NOTICE</span>
      <!-- <router-link class="nav-link" to="/faq">FAQ</router-link> -->
      <span class="nav-link" :class="{ active: ind == 5 }" @click="jump(5)">CONTACT US</span>
      <!-- <a class="nav-link" href="https://agent-credit-h5.brmfbank.com/">MerchantLoan</a> -->

      <!-- <router-link class="nav-link" to="/faq">FAQ</router-link> -->
    </div>
  </div>
</template>
<script>
import router from '@/router/index'
import getQueryString from "@/utils/getQuery.js";
export default {
  data() {
    return {
      env: "",
      ind: 0,
      hoverInd: 0,
      isShow: false
    };
  },
  mounted() {
    this.env = getQueryString("env");
    this.ind = this.defaultInd || 0
  },
  props: ["isFixed", 'defaultInd'],
  methods: {
    jump(ind) {
      this.ind = ind
      console.log(ind)
      window.sessionStorage.setItem('toScrollInd', ind)
      this.$emit('toScroll', ind)
      const _this = this
      if (_this.defaultInd) {
        router.replace('/home')
      }
    },
    showDialog() {
      this.isShow = true
    },
    mouseenter(ind) {
      this.hoverInd = ind
    },
    mouseleave() {
      this.isShow = false
      this.hoverInd = 0
    }
  },
  destroyed() {
    this.hoverInd = 0
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/public.scss";
.nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 88px;
  background: #fff;
  &.bg-white {
    background-color: #fff;
    box-shadow: 0px 1px 27px 5px rgba(0, 0, 0, 0.06);
  }
  .main {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 120px;
    .logo {
      width: 120px;
    }
    .nav-link {
      width: auto;
      height: 100%;
      line-height: 88px;
      font-size: 24px;
      margin-left: 110px;
      cursor: pointer;
      position: relative;
      ul {
        position: absolute;
        top: 88px;
        left: -84px;
        width: 242px;
        height: 100px;
        overflow: hidden;
        border-radius: 8px;
        background: #fff;
        .loans-item {
          width: 100%;
          height: 55px;
          @include flex-base;
          padding: 0 6px;
          background: #fff;
          &.active {
            background: rgba(28, 88, 245, 0.1);
            span {
              color: #210f60;
              font-size: 14px;
              font-weight: 600;
            }
          }
          img {
            width: 34px;
            height: 34px;
          }
          span {
            flex: 1;
            margin-left: 4px;
            color: rgba(0, 0, 0, 0.85);
            font-size: 14px;
            line-height: 50px;
          }
        }
      }
      &.active {
        position: relative;
        font-weight: bold;
        color: #210F60;
        border-bottom: 4px solid #1C58F5;
        span {
          color: #210F60;
        }
      }
    }
  }
}
</style>
